export default "__VITE_ASSET__BRRsWHlA__"